import { colors, colors2, ellipsis, injectHttps, SANS_2, transition, UI_BODY_SEMIBOLD_SM_DF } from "oolib";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { usePlatformBuilderContext } from "../../../../../../../contexts/platformBuilderContext";
import { __CheckAccessViaConfig } from "../../../../../../../utils/accessControl";
import { useGetQueryData } from "../../../../../../../utils/react-query-hooks/general";
import { useGetDisplayForLandingPageLinks } from "../../../../../utils/useGetDisplayForLandingPageLinks";
import { useIsThisLinkActive } from "../../utils/useIsThisLinkActive";
const { grey5, grey10 } = colors2;

const StyledLinkWrapper = styled.li`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 1.2rem 0 1.2rem;
  background-color: ${({ isActive }) => (isActive ?  grey10 : "none")};
  border-radius: 3.7rem;

  width: 100%;
  max-width: ${({ useFixedWidth, maxWidth }) => useFixedWidth && maxWidth ? `${maxWidth}px` : '100%'};
  ${({ useFixedWidth }) => useFixedWidth ? ellipsis : ''}
  &:hover {
    background-color: ${grey10};
  }
`;

const StyledInternalLink = styled(Link)`
  display: flex;
  align-items: center;
  height: 100%;
`;

const StyledExternalLink = styled.a`
  display: flex;
  align-items: center;
  height: 100%;
`;

const StyledTextWrapper = styled(UI_BODY_SEMIBOLD_SM_DF)`
  width: 100%;
  ${({ useFixedWidth }) => useFixedWidth ? ellipsis : ''}
`

export const PRIMLink = ({
  id,
  to, // can be a location obj or a string
  display: _display,
  thisNavConfig, // needed specifically for the type = landingPage, wherein, we wanna make an api call to get the latest title and set that as the display
  accessControl,
  dontRender = false,
  useFixedWidth = false,
  maxWidth = 100,
}) => {
  const { inGlobalNavBuilder } = usePlatformBuilderContext();
  const { isThisLinkActive } = useIsThisLinkActive({ matchLogic: 'pathname-start-match' });
  const { user } = useGetQueryData("userData") || {};

  const { display, TextLoader } = useGetDisplayForLandingPageLinks({
    thisNavConfig,
    _display,
  });

  const genDisplay = () => (
    <StyledLinkWrapper isActive={isThisLinkActive({ to })} key={to} useFixedWidth={useFixedWidth} maxWidth={maxWidth}>
      {TextLoader ? <TextLoader /> : <StyledTextWrapper useFixedWidth={useFixedWidth}>{display}</StyledTextWrapper>}
    </StyledLinkWrapper>
  );

  if (dontRender === true) return null; // checkAccessAndGen(Content/Profile)PageLinkProps can send such a prop cuz of access control

  if (accessControl && !__CheckAccessViaConfig({ ...accessControl, user }))
    return null;

  let genInternalOrExternalLinkComp =
    to.substring(0, 1) === "/" ? "internal" : "external";

  return inGlobalNavBuilder ? (
    genDisplay()
  ) : genInternalOrExternalLinkComp === "internal" ? (
    <StyledInternalLink
      id={id}
      to={to} // passing null/undefined to deactivate link causes issue, page breaks
      children={genDisplay()}
    />
  ) : (
    <StyledExternalLink
      id={id}
      href={injectHttps(to)}
      target="_blank"
      children={genDisplay()}
    />
  );
};

